module.exports = __webpack_public_path__ + "img/44.bdfbccd8.jpeg";